import { getCurrentSession, supabase } from './supabase'

export type EditableWorkspaceRole = 'admin' | 'manager' | 'member'

export async function saveWorkspaceMemberRole(teamId: string, identity: { member_user_id: string } | { member_slack_user_id: string }, role: EditableWorkspaceRole) {
  const session = await getCurrentSession()
  if (!session) throw new Error('Sign in again to change roles')
  const { data, error } = await supabase.functions.invoke('manage-pods', {
    body: { action: 'update_role', team_id: teamId, ...identity, role },
    headers: { Authorization: `Bearer ${session.access_token}` },
  })
  if (error) {
    const response = (error as { context?: Response }).context
    let message = 'Unable to change role. Please try again.'
    if (response?.clone) {
      try { message = (await response.clone().json()).error || message } catch { /* Gateway responses can be empty. */ }
    }
    throw new Error(message)
  }
  if (!data?.success) throw new Error(data?.error || 'Unable to change role')
}
